import React, { useEffect, useContext } from 'react';
import Header from './components/Header';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from 'store/context/GlobalContext';
import { fetchUser } from 'services/authService';
import * as action from "store/actions";

export default function Public(props) {
    const { children } = props;
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
    const user = useSelector((state) => state.Auth.user);
    const context = useContext(GlobalContext);
    const { setUserData } = context;

    useEffect(() => {
        if(!isAuthenticated || user.login_id === "") return;
        
        let result = {
            login_id: user.login_id,
            login_name: user.login_name,
        };
        const formData = new FormData();
        Object.keys(result).map(function(key) {
            return formData.append(key, result[key]);
        });

        fetchUser(formData).then(res => {
            if(!res.result){
                setTimeout(() => {
                    fetchUser(formData).then(res2 => {
                        if(!res.result){
                            dispatch(action.authLogout());
                        }else{
                            setUserData(res2);
                        }
                    })
                }, 1500)
            }else{
                setUserData(res);
            }
        })
    }, [user, isAuthenticated])
    
    return (<>
        <Header/>
        { children }
		{/* <main className={!context.pageState.header ? 'pt-0' : ''}>
			{ children }
		</main> */}
    </>)
}